"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoTip = InfoTip;
var _lib = require("@a1s/lib");
var _react = _interopRequireWildcard(require("react"));
var _ = require("..");
var _styled = require("./styled");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
//
// Main component
// -------------------------------------------------------------------------------------------------

/**
 * The `InfoTip` component renders a small button that, when hovered over, displays a tooltip with
 * additional information.
 *
 * @alpha
 */

function InfoTip({
  children,
  testId
}) {
  // Generate a unique `id` so the the button can be associated with the tooltip
  const idRef = (0, _react.useRef)((0, _lib.random)(5));
  function handleKeyDown(event) {
    var _event$currentTarget;
    // Element with `role="tooltip" are supposed to be dimissed when the "Escape" key
    // is pressed:
    // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/Tooltip_Role
    if (event.key === 'Escape') (_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 ? void 0 : _event$currentTarget.blur();
  }
  return /*#__PURE__*/_react.default.createElement(_styled.StyledContainer, {
    "data-testid": testId
  }, /*#__PURE__*/_react.default.createElement(_.TinyButton, {
    "aria-describedby": idRef.current,
    onKeyDown: handleKeyDown
  }, "?"), /*#__PURE__*/_react.default.createElement(_styled.TooltipWrapper, {
    id: idRef.current,
    role: "tooltip",
    tabIndex: -1
  }, /*#__PURE__*/_react.default.createElement(_.Tooltip, null, children)));
}